import React from "react";
import NewsletterSignUp from "./NewsletterSignUp";
import LoginPageLinks from "newApp/utilities/LoginPageLinks";

const LoginFooter = () => {
    return (<div className="container-fluid" id="footer">
        <div className="footer-content legal-footer container-fluid">
            <div className="row">
                <div className="row footer-top-row">
                    <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                        <div className="footer-links">
                            <ul>
                                <li>
                                    <div className="bottom-links-title"><a href={LoginPageLinks.SoleSource}>Explore Solutions</a></div>
                                    <div className="bottom-links-products">Sentri7 Clinical Surveillance and Simplifi+ Pharmacy Compliance.</div>
                                </li>
                                <li>
                                    <div><a href={LoginPageLinks.ContactUs}>Contact Us</a>
                                    </div>
                                </li>
                                <li>
                                    <div><a href={LoginPageLinks.AboutUs}>About Us</a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                        <NewsletterSignUp/>
                    </div>
                    <div className="hidden-xs hidden-sm col-md-1 col-lg-1 vertical-divider">
                        <div className="row" />
                    </div>
                    <div className="col-xs-12 col-md-3 col-lg-3">
                        <div className="media-contacts">
                            <div>Follow Wolters Kluwer</div>
                            <ul>
                                <li>
                                    <div className="field-link"><a
                                        className="media-icons ion-social-facebook"
                                        href={LoginPageLinks.Facebook}
                                        target="_blank" rel ="noopener">Facebook</a></div>
                                </li>
                                <li>
                                    <div className="field-link"><a
                                        className="media-icons ion-social-twitter"
                                        href={LoginPageLinks.Twitter}
                                        target="_blank" rel ="noopener">Twitter</a></div>
                                </li>
                                <li>
                                    <div className="field-link"><a
                                        className="media-icons ion-social-linkedin-outline"
                                        href={LoginPageLinks.Linkedin}
                                        target="_blank" rel ="noopener">LinkedIn</a></div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="row footer-bottom-row">
                    <div className="col-12">
                        <a title="WK Logo" href={LoginPageLinks.SoleSource}>
                            <div className="footer-logo transparentLogo-white"/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div className="row footer-content-bottom">
            <div className="link-list footer-links">
                <ul>
                    <li>
                        <div className="privacy-link">
                            <a href={LoginPageLinks.PrivacyCookies}
                                target="_blank" rel ="noopener">Privacy &amp; Cookies
                            </a>
                        </div>
                    </li>
                </ul>
                <div className="rich-text article-text">
                    <p className="copyright-text">© {new Date().getFullYear()} Wolters Kluwer N.V. and/or its
                                subsidiaries. All rights reserved.</p>
                </div>
            </div>
        </div>
    </div>
    );
};

export default LoginFooter;
